import Swiper, {Navigation, EffectFade, Autoplay, Pagination} from 'swiper';

const postsSwiper = new Swiper('.front-blog .swiper', {
	modules: [Navigation],
	slidesPerView: 1,
	spaceBetween: 15,
	navigation: {
		nextEl: '.front-blog .swiper-next',
		prevEl: '.front-blog .swiper-prev',
	},
	breakpoints: {
		768: {
			slidesPerView: 2,
			spaceBetween: 20,
		},
		980: {
			slidesPerView: 3,
			spaceBetween: 30,
		},
	},
	loop: true,
});

const testimonialSlider = document.querySelector(".front-testimonials__swiper");
if (testimonialSlider) {
	const testimonialSliderSwiper = new Swiper(".front-testimonials__swiper", {
		modules: [Navigation, Autoplay],
		slidesPerView: 1.15,
		navigation: {
			nextEl: ".front-testimonials__next",
			prevEl: ".front-testimonials__prev",
		},
		spaceBetween: 15,
		centeredSlides: true,
		loop: true,
		autoplay: {
			delay: 9000,
		},
		breakpoints: {
			// when window width is >= 640px
			960: {
				slidesPerView: 1.75,
				spaceBetween: 30,
			},
			1280: {
				slidesPerView: 2,
				spaceBetween: 30,
			},
			1600: {
				slidesPerView: 3,
				spaceBetween: 30,
			},
		},
	});
}

// activate before and after slider
const beforeAfterSwiper = document.querySelector('.before-after-slider');
if ( beforeAfterSwiper ) {
	const beforeAfterSwiper = new Swiper ('.before-after-slider', {
		modules: [Navigation, EffectFade, Autoplay],
		// Optional parameters
		slidesPerView: 1,
		navigation: {
			nextEl: ".before-after-slider-next",
			prevEl: ".before-after-slider-prev",
		},
		loop: true,
		autoplay: {
			delay: 3000,
		},
		// Responsive breakpoints
		breakpoints: {
			// when window width is >= 320px
			320: {
				slidesPerView: 1,
			},
			480: {
				slidesPerView: 2,
				spaceBetween: 24,
			}
		}
	});

	const fragmentElement = document.querySelector('.before-after-slider-fragment');
	if (fragmentElement) {
		beforeAfterSwiper.on('slideChange', () => {
			const currentSlide = beforeAfterSwiper.realIndex + 1;
			const totalSlides = beforeAfterSwiper.slides.length - beforeAfterSwiper.loopedSlides * 2;
			fragmentElement.textContent = `${currentSlide}/${totalSlides}`;
		});

		// Initialize the fragment with the first slide position
		const initialSlide = beforeAfterSwiper.realIndex + 1;
		const totalSlides = beforeAfterSwiper.slides.length - beforeAfterSwiper.loopedSlides * 2;
		fragmentElement.textContent = `${initialSlide}/${totalSlides}`;
	}

}

const logoSliderEl = document.querySelector('.front-meet__logos-mobile');

if (logoSliderEl) {
	new Swiper(logoSliderEl, {
		modules: [Autoplay],
		slidesPerView: 3.2,
		spaceBetween: 30,
		centeredSlides: true,
		loop: true,
		speed: 4000,
		allowTouchMove: false,
		autoplay: {
			delay: 0,
			disableOnInteraction: false,
			pauseOnMouseEnter: false,
		},
		breakpoints: {
			0: {
				slidesPerView: 1,
				spaceBetween: 16,
			},
			480: {
				slidesPerView: 3.2,
				spaceBetween: 30,
			},
		},
	});
}

/**
 * Procedures Slider
 */

const proceduresSlider = document.querySelector(
	".front-procedures-slider .swiper-container"
);

if (proceduresSlider) {
	// for procedure slider we need custom pagination, so we create
	// array of names for it
	let labels = [];

	document
		.querySelectorAll(".front-procedures-slider .swiper-slide")
		.forEach((slide) => {
			labels.push(slide.dataset.title);
		});

	new Swiper(proceduresSlider, {
		modules: [Autoplay, EffectFade, Pagination],
		slidesPerView: 1,
		spaceBetween: 250,
		centeredSlides: true,
		loop: true,
		autoplay: {
			delay: 8000,
		},
		autoHeight: true,
		effect: "fade",
		speed: 500,
		fadeEffect: {
			crossFade: true,
		},
		allowTouchMove: true,
		// If we need pagination
		pagination: {
			el: ".front-procedures-slider__pagination",
			clickable: true,
			renderBullet: function (index, className) {
				let label = labels[index];

				const arrows = {
					"{{": "",
					"}}": ""
				};

				Object.keys(arrows).forEach((key) => {
					label = label.replaceAll(key, arrows[key]);
				});

				return (
					`<div class="${className}">
						<div class="inner">${label}</div>
					</div>`
				);
			},
		},
	});
}

